const withUrlParams = (url, params) =>
  Object.entries(params).reduce(
    (url, [key, value]) => url.replace(`:${key}`, encodeURIComponent(value)),
    url
  );

export default withUrlParams;
